import * as Yup from 'yup';

export const componentGroupSchema = Yup.object().shape({
  description: Yup.string().required('Descrição é obrigatória.'),
  order: Yup.string().required('Ordem é obrigatória.'),
});